/**
 * @generated SignedSource<<e48823196f1dcdfc681bd6f36425dd13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type desktopRecorderApiDesktopRecorderQuery$variables = {};
export type desktopRecorderApiDesktopRecorderQuery$data = {
  readonly account: {
    readonly allowBotlessRecording: boolean;
  };
};
export type desktopRecorderApiDesktopRecorderQuery = {
  response: desktopRecorderApiDesktopRecorderQuery$data;
  variables: desktopRecorderApiDesktopRecorderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowBotlessRecording",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "desktopRecorderApiDesktopRecorderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "desktopRecorderApiDesktopRecorderQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "53f00393b55c6a63ed61414cfe70fe9b",
    "id": null,
    "metadata": {},
    "name": "desktopRecorderApiDesktopRecorderQuery",
    "operationKind": "query",
    "text": "query desktopRecorderApiDesktopRecorderQuery {\n  account {\n    allowBotlessRecording\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "b8e3b4d1d0c8ccc702efcde7ac414230";

export default node;
